import TimeLine from "../../../../src/components/TimeLine.js";
import React from 'react';
export default {
  TimeLine,
  React
};